import {NgModule}                        from '@angular/core';
import {CommonModule}                    from '@angular/common';
import {SharedModule}                    from '../shared/shared.module';
import {LayoutComponent}                 from './components/layout/layout.component';
import {MatIconModule, MatToolbarModule} from '@angular/material';
import {RouterModule}                    from '@angular/router';
import { CertificateService } from '../certificate/services/certificate.service';

@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MatIconModule,
    MatToolbarModule
  ],
  providers: [
    CertificateService
  ]
})
export class LayoutModule { }
